import React, { useEffect, useState, useRef } from "react";
import { FormGroup } from "components/common";
import { NotificationManager } from "react-notifications";
import { Row, Input } from "reactstrap";
import { Trans } from "react-i18next";
import { useForm } from "hooks";
import InputFile from "components/common/InputFile";
import { PayrollClient } from "services";


export const AttachmentLine = ({ payroll, t, employee, url, model = "local", history, type, old, setReload, reload}) => {

    const { Form } = useForm({ model });


    const [item, setItem] = useState({ 'employee': null, 'type': ''})
    const payroll_client = PayrollClient()
    const ref = useRef();
    console.log('itme ', item)
    useEffect(() => {
        setItem({ ...item, employee: employee })
        if (old) {
            setItem({ ...item, employee: employee, type: old.type, attachment: old.attachment , id:old.id })
        }
    }, [employee, old]);

    const validate = (item) => {

        if (item.attachment.file === "" || item.attachment.file === null || item.type ==="") {
            NotificationManager.error(t('All fields are required'))
            return false
        }
        return true
    }


    async function onSubmit(item, method, url) {
        if (!validate(item)) {
            return
        }
        try {
            await payroll_client({method:method, url:url, data:item})  
            setReload((old) =>(!old))
            setItem({ ...item, employee: employee, type: '', file: ""})
            if(ref.current){
                ref.current.value=""
            }
            NotificationManager.success(t("Saved successfully"));
        } finally {
        }
    }

    function Submit(event) {
        event.preventDefault()
        onSubmit(item, "POST", url )
    }

    function Update(event) {
        event.preventDefault()
        onSubmit(item, "PUT", url = `employee_attachments/${item.id}`)
    }

    function remove(event) {
        event.preventDefault()
        onSubmit(item, "DELETE", url = `employee_attachments/${item.id}`)
    }

    return (
        <Form>
                <Row className="align-items-center">
                    <div className="col-1">
                    <FormGroup>
                            <label htmlFor="type"><Trans>ID</Trans></label>
                            <Input type="text" value={item.id || "#"} disabled></Input>
                        </FormGroup>
                    </div>
                    <div className="col-4">
                        <FormGroup>
                            <label htmlFor="type"><Trans>Type</Trans></label>
                            <Input type="text" value={item.type} onChange={(e) =>{setItem({...item, type:e.target.value})}}></Input>
                        </FormGroup>
                    </div>
                    <div className="col-4">
                        <FormGroup className="pb-2 pt-2">
                            <label htmlFor="Attachment" ref={ref}><Trans>Attachment</Trans></label>
                            <InputFile innerRef={ref} t={t} file={item.attachment || ""} setData={setItem} disabled={employee === null}></InputFile>
                        </FormGroup>
                    </div>
                    <div className="col-3">
                        <FormGroup className="pb-2 pt-2">
                            {item.id ?
                                <>
                                    <input type="submit" value={t('Update')} className="btn btn-primary" onClick={Update} disabled={employee === null} />
                                    <input type="submit" value={t('Delete')} className="btn btn-danger" onClick={remove} disabled={employee === null} />
                                </>
                                :
                                <input type="submit" value={t('Add')} className="btn btn-primary" onClick={Submit} disabled={employee === null} />
                            }
                        </FormGroup>
                    </div>
                </Row>
        </Form>
    );
};

export default AttachmentLine;
